import { parse } from 'qs';
import {
  ONBOARDING_SETUP,
  USER_ONBOARDING_WITHOUT_OPTIONS_SCREEN,
} from '../../constants/routes';
import routesList from '../../routesList';
import useLayoutStore from '../../stores/layoutStore';
import { useFeatureSplit } from '../useFeatureSplit';
import useMobileApp from '../useMobileApp';
import { SplitNames, TreatmentTypes } from '../useSplitSdkConfig/constants';
import useMultiAssemblySlug from '../useMultiAssemblySlug';
import { getIsSlugCodeFromURLValid } from '../../Utils/common';

const useGetCanDisplayOptInBanner = () => {
  const { isMobileApp, isMobileAppV3 } = useMobileApp();
  const { isEmbeddedInMainApp } = useLayoutStore();
  const { slugUrl: slugUrlFromAPI } = useMultiAssemblySlug();
  const slugUrlFromPathname = window.location.pathname.split('/')[1];
  const isSlugCodeFromURLValid = getIsSlugCodeFromURLValid(
    slugUrlFromAPI,
    slugUrlFromPathname,
  );

  const { treatment: assemblyV3Experience } = useFeatureSplit(
    SplitNames.AssemblyV3Experience,
  );

  const { treatment: enforceV3Experience } = useFeatureSplit(
    SplitNames.EnforceV3Experience,
  );

  const shouldEnforceV3Experience = enforceV3Experience === TreatmentTypes.ON;

  const parsedParams = parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const errorCodeFromURL = parsedParams && parsedParams.error;

  const isAssemblyV3ExperienceOn = assemblyV3Experience === TreatmentTypes.ON;
  const optInBannerHiddenPathnames = [
    '/extInstalled',
    '/fullscreen',
    '/answer',
    `/user/set-details`,
    '/user/account-setup',
    ONBOARDING_SETUP,
    USER_ONBOARDING_WITHOUT_OPTIONS_SCREEN,
    routesList.CONNECTION_REDIRECT_URL,
    routesList.SIGN_OUT,
    '/edit/',
    '/slack/onboard/',
    '/gSuite/onboard/',
    '/office365/onboard/',
    '/404',
    '/template',
  ];

  const canDisplayOptInBanner =
    isAssemblyV3ExperienceOn &&
    !shouldEnforceV3Experience &&
    !isMobileApp &&
    !isMobileAppV3 &&
    !isEmbeddedInMainApp &&
    !errorCodeFromURL &&
    !optInBannerHiddenPathnames.some((path) =>
      window.location.pathname.includes(path),
    ) &&
    isSlugCodeFromURLValid;

  return { canDisplayOptInBanner };
};

export default useGetCanDisplayOptInBanner;
